import AccountsList from './AccountsList';

export default function PayablesList() {
    return <AccountsList kind="payable" />;
}
